import OperationalInputCurveController from './curve.controller';
import './curve.css';

const template = require<string>('./curve.html');

const curveComponent:ng.IComponentOptions = {
  bindings: {
    stationId: '<',
    parsedTelegram: '<',
    parsedTelegramDate: '<',
    onModelChange: '&'
  },
  controller: OperationalInputCurveController,
  template
};

export default curveComponent;



/** WEBPACK FOOTER **
 ** ./app/operational/input/curve.component.ts
 **/